<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi"><a id="page_7">To my mother,</a></p><a id="page_7">
<p class="dedi1">Without you, my words would have never found the page. Thank you for your incredible inner beauty and strength. My deepest regret is that I did not see all of you until you were gone.</p>
<div class="img_container">
<img alt="images" src="images/fig1.jpg" style="width:60%;"/>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?0e3c4a4b